import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetProject } from '../selectors/projects'

import { setCustomFieldValue } from '../actions/custom-fields';

import CustomFields from './custom-fields';

class ProjectCustomFields extends PureComponent {
    handleCustomFieldChange = (id, value) => {
        setCustomFieldValue('project', this.props.id, id, value);
    }

    render() {
        return null;
        return (
            <CustomFields
                type="single-line"
                association="project"
                values={this.props.project && this.props.project.fields}
                onChange={this.handleCustomFieldChange}
            />
        )
    }
};

const makeMapStateToProps = () => {
    const getProject = makeGetProject();

    return ({ projects }, ownProps) => ({
        project: getProject(projects.items, ownProps.id)
    });
}

export default connect(makeMapStateToProps)(ProjectCustomFields);
